import {Button} from "semantic-ui-react";
import styled from "styled-components";

export const PrimaryButton = styled(Button)`
  background: black!important;
  color: white!important;;
  border: 2px solid black!important;;
  border-radius: 0!important;;

  &:hover {
    background: white!important;;
    color: black!important;;
  }
`;


/**


 .ui.button.whiteButton {
    background: white;
    color: black;
    border: 2px solid #000;
    border-radius: 0;
}

 .ui.button.whiteButton:hover {
    background: black;
    color: white;
}

 */
